import { get_js1ale1wr4fbvs0 as get_js } from '../../../../kotlin-kotlin-stdlib/kotlin/js/JsClass.mjs';
import { NothingSerializer_getInstancejqk7fqid1kug as NothingSerializer_getInstance } from './BuiltInSerializers.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { notRegisteredMessage3kjs77vaiklv as notRegisteredMessage } from './Platform.common.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../SerializersJs.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { findAssociatedObject1kb88g16k1goa as findAssociatedObject } from '../../../../kotlin-kotlin-stdlib/reflectionJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from './PluginHelperInterfaces.mjs';
import { IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_indicesc04v40g017hw as get_indices,
  get_indices377latqcai313 as get_indices_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  DoubleCompanionObject_instance3q51gr7gsd0au as DoubleCompanionObject_instance,
  FloatCompanionObject_instance367t6x2s4xzmv as FloatCompanionObject_instance,
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
  ShortCompanionObject_instance3vq120mx8545m as ShortCompanionObject_instance,
  ByteCompanionObject_instance9rvhjp0l184i as ByteCompanionObject_instance,
  BooleanCompanionObject_instance29o5h9ajgjmec as BooleanCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  serializer1x79l67jvwntn as serializer,
  serializer345btyh1f2y1j as serializer_0,
  CharArraySerializerklmg8gfnksga as CharArraySerializer,
  serializer1wpgysz06u9ol as serializer_1,
  DoubleArraySerializertger6kqq08hw as DoubleArraySerializer,
  serializer3x9uckd1deom as serializer_2,
  FloatArraySerializerr6nw52je2tta as FloatArraySerializer,
  serializerodflzzf6s3fp as serializer_3,
  LongArraySerializer13aridd43vtw2 as LongArraySerializer,
  serializer2lw83vwvpnyms as serializer_4,
  ULongArraySerializer2p6vevd8k2lpe as ULongArraySerializer,
  serializer1hu9wv9at41ww as serializer_5,
  IntArraySerializer1m3fo301mmjdr as IntArraySerializer,
  serializer3ikrxnm8b29d6 as serializer_6,
  UIntArraySerializermosjtc8kcdu0 as UIntArraySerializer,
  serializer1tw0a8bv7lkga as serializer_7,
  ShortArraySerializer316766pkdw188 as ShortArraySerializer,
  serializer1q7c5q67ysppr as serializer_8,
  UShortArraySerializer2x9pkk602s3ka as UShortArraySerializer,
  serializer1r0h5yakm679b as serializer_9,
  ByteArraySerializersn06x87bo7h0 as ByteArraySerializer,
  serializer36584sjyg5661 as serializer_10,
  UByteArraySerializer1sccfecbzq55o as UByteArraySerializer,
  serializer3u3hsxnenk49x as serializer_11,
  BooleanArraySerializer1s3kgnkejzqxt as BooleanArraySerializer,
  serializer1cdzkc3mnhoc4 as serializer_12,
  NothingSerializer3oixyyf77l4xt as NothingSerializer,
  serializer37oyvz7rc4nep as serializer_13,
  serializer1j5a5justjsv5 as serializer_14,
  serializer1x80idigipeic as serializer_15,
} from '../builtins/BuiltinSerializers.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  Char19o2r8palgjof as Char,
  Companion_getInstance2e3h8n26rh23 as Companion_getInstance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Companion_instance3skn40jhkoxyn as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import {
  ULong3f9k7s38t3rfp as ULong,
  Companion_getInstance1puqqwzccfvrg as Companion_getInstance_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { ULongArray3nd0d80mdwjj8 as ULongArray } from '../../../../kotlin-kotlin-stdlib/kotlin/ULongArray.mjs';
import {
  UInt1hthisrv6cndi as UInt,
  Companion_getInstanceuedpedmz4g65 as Companion_getInstance_1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { UIntArrayrp6cv44n5v4y as UIntArray } from '../../../../kotlin-kotlin-stdlib/kotlin/UIntArray.mjs';
import {
  UShort26xnqty60t7le as UShort,
  Companion_getInstance2du03jiluw9jj as Companion_getInstance_2,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { UShortArray11avpmknxdgvv as UShortArray } from '../../../../kotlin-kotlin-stdlib/kotlin/UShortArray.mjs';
import {
  UBytep4j7r1t64gz1 as UByte,
  Companion_getInstance1trnkq9cty7vr as Companion_getInstance_3,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { UByteArray2qu4d6gwssdf9 as UByteArray } from '../../../../kotlin-kotlin-stdlib/kotlin/UByteArray.mjs';
import {
  Unitkvevlwgzwiuc as Unit,
  Unit_instance1fbcbse1fwigr as Unit_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_4,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  Instant2s2zyzgfc4947 as Instant,
  Companion_getInstance1jfygh5e58evr as Companion_getInstance_5,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import {
  Uuid1zxgztb7abqxx as Uuid,
  Companion_getInstance1cdckxf15vkye as Companion_getInstance_6,
} from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance_0,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function compiledSerializerImpl(_this__u8e3s4) {
  var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().xf()) {
      tmp_0 = NothingSerializer_getInstance();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp1_safe_receiver = get_js(_this__u8e3s4).Companion;
      tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.serializer();
    }
    var tmp_1 = tmp_0;
    tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer()) : false) ? tmp_1 : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
  throw SerializationException().p10(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
}
function isInterface_0(_this__u8e3s4) {
  return get_isInterfaceHack(_this__u8e3s4);
}
function isReferenceArray(rootClass) {
  return rootClass.equals(PrimitiveClasses_getInstance().fg());
}
function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
  var tmp;
  try {
    // Inline function 'kotlin.reflect.findAssociatedObject' call
    var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith()));
    var tmp_0;
    if (!(assocObject == null) ? isInterface(assocObject, KSerializer()) : false) {
      tmp_0 = isInterface(assocObject, KSerializer()) ? assocObject : THROW_CCE();
    } else {
      if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory()) : false) {
        var tmp_1 = assocObject.f1c(args.slice());
        tmp_0 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
      } else {
        tmp_0 = null;
      }
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_2;
    var e = $p;
    tmp_2 = null;
    tmp = tmp_2;
  }
  return tmp;
}
function createCache(factory) {
  return new (createCache$1())(factory);
}
function createParametrizedCache(factory) {
  return new (createParametrizedCache$1())(factory);
}
function getChecked(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException().je('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function getChecked_0(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException().je('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function toNativeArrayImpl(_this__u8e3s4, eClass) {
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(_this__u8e3s4);
}
function initBuiltins() {
  return mapOf([to(PrimitiveClasses_getInstance().gg(), serializer(StringCompanionObject_instance)), to(getKClass(Char()), serializer_0(Companion_getInstance())), to(PrimitiveClasses_getInstance().jg(), CharArraySerializer()), to(PrimitiveClasses_getInstance().eg(), serializer_1(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().pg(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().dg(), serializer_2(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().og(), FloatArraySerializer()), to(PrimitiveClasses_getInstance().cg(), serializer_3(Companion_instance)), to(PrimitiveClasses_getInstance().ng(), LongArraySerializer()), to(getKClass(ULong()), serializer_4(Companion_getInstance_0())), to(getKClass(ULongArray()), ULongArraySerializer()), to(PrimitiveClasses_getInstance().bg(), serializer_5(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().mg(), IntArraySerializer()), to(getKClass(UInt()), serializer_6(Companion_getInstance_1())), to(getKClass(UIntArray()), UIntArraySerializer()), to(PrimitiveClasses_getInstance().ag(), serializer_7(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().lg(), ShortArraySerializer()), to(getKClass(UShort()), serializer_8(Companion_getInstance_2())), to(getKClass(UShortArray()), UShortArraySerializer()), to(PrimitiveClasses_getInstance().zf(), serializer_9(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().kg(), ByteArraySerializer()), to(getKClass(UByte()), serializer_10(Companion_getInstance_3())), to(getKClass(UByteArray()), UByteArraySerializer()), to(PrimitiveClasses_getInstance().yf(), serializer_11(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().ig(), BooleanArraySerializer()), to(getKClass(Unit()), serializer_12(Unit_instance)), to(PrimitiveClasses_getInstance().xf(), NothingSerializer()), to(getKClass(Duration()), serializer_13(Companion_getInstance_4())), to(getKClass(Instant()), serializer_14(Companion_getInstance_5())), to(getKClass(Uuid()), serializer_15(Companion_getInstance_6()))]);
}
function get_isInterfaceHack(_this__u8e3s4) {
  if (_this__u8e3s4 === PrimitiveClasses_getInstance().xf())
    return false;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
}
var createCache$1Class;
function createCache$1() {
  if (createCache$1Class === VOID) {
    class $ {
      constructor($factory) {
        this.z1l_1 = $factory;
      }
      j11(key) {
        return this.z1l_1(key);
      }
    }
    initMetadataForClass($);
    createCache$1Class = $;
  }
  return createCache$1Class;
}
var createParametrizedCache$1Class;
function createParametrizedCache$1() {
  if (createParametrizedCache$1Class === VOID) {
    class $ {
      constructor($factory) {
        this.a1m_1 = $factory;
      }
      k11(key, types) {
        // Inline function 'kotlin.runCatching' call
        var tmp;
        try {
          // Inline function 'kotlin.Companion.success' call
          var value = this.a1m_1(key, types);
          tmp = _Result___init__impl__xyqfz8(value);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
    }
    initMetadataForClass($);
    createParametrizedCache$1Class = $;
  }
  return createParametrizedCache$1Class;
}
//region block: exports
export {
  compiledSerializerImpl as compiledSerializerImpl2ykwhos63n897,
  constructSerializerForGivenTypeArgs as constructSerializerForGivenTypeArgsj1zk005on26m,
  createCache as createCacheduynpeymxvy7,
  createParametrizedCache as createParametrizedCache2j3ou5aipnogv,
  getChecked as getChecked1o70dkx10jwym,
  getChecked_0 as getChecked3avs2psuwt1xd,
  initBuiltins as initBuiltins3cd82qqvse108,
  isInterface_0 as isInterface150ul88kmyj8d,
  isReferenceArray as isReferenceArray1zykjthfz743b,
  platformSpecificSerializerNotRegistered as platformSpecificSerializerNotRegistered35vpw6xk2l454,
  toNativeArrayImpl as toNativeArrayImpl3ha7yn5cjhfpi,
};
//endregion

//# sourceMappingURL=Platform.mjs.map
